// App.js
import React from 'react';
import Header from './components/Header';
import Intro from './components/Intro';
import Benefits from './components/Benefits';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import Waitlist from './components/Waitlist';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Intro />
      <Benefits />
      <Features />
      <Testimonials />
      <Waitlist />
      <Footer />
    </div>
  );
}

export default App;
